import { useDispatch } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { GetObjectivesActivities } from "../../../Redux/Reducers/BudgetInformation/ObjectivesActivities";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetObObjectives } from "../../../Redux/Reducers/BudgetInformation/Objectives";
import InputAHSF from "../../../Components/InputAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import MonthsImplementationDirectBudgetCosts from "./MonthsImplementationDirectBudgetCosts";
import {
  AddDirectCosts,
  GetABI_AB_ItemTypeDirectCosts,
  GetDirectCosts,
  ItemTypeDirectCostsListFilter,
  setClearMonth,
  setClearValidationList,
  UpdateDirectCosts,
  ValidationDirectCosts,
} from "../../../Redux/Reducers/BudgetInformation/DirectCosts";
import { GetBI_TimelineInformation } from "../../../Redux/Reducers/BudgetInformation/TimelineInformation";

import $ from "jquery";
import "./style.css";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
const BudgetDirectCostsAddEdit = (props) => {
  const [dataEditMonth, setDataEditMonth] = useState([]);
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const [bI_ObjectiveActivitiesId, setBI_ObjectiveActivitiesId] =
    useState(null);
  const [BI_ObjectivesId, setBI_ObjectivesId] = useState(null);
  const [ActivityDescription, setActivityDescription] = useState(null);
  const [BI_AB_ItemTypeId, setBI_AB_ItemTypeId] = useState(null);
  const [ItemName, setItemName] = useState(null);
  const [
    DescriptionAndDetailsOfItemCalculation,
    setDescriptionAndDetailsOfItemCalculation,
  ] = useState(null);
  const [NumberOfUnits, setNumberOfUnits] = useState(null);
  const [Frequency, setFrequency] = useState(null);
  const [beneficiaryContribution, setBeneficiaryContribution] = useState(null);
  const [ShomanContribution, setShomanContribution] = useState(null);
  const [data, setData] = useState();
  const [Total, setTotal] = useState(null);
  const [UnitPrice, setUnitPrice] = useState(null);
  const dispatch = useDispatch();
  const AppGuid = useParams();

  const [showMessageMonth, setShowMessageMonth] = useState(false);
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  const ObjectivesActivitiesList = useSelector(
    (state) => state.ObjectivesActivities.ObjectivesActivitiesList
  );
  const ObjectivesList = useSelector(
    (state) => state.objectives.ObjectivesList
  );
  const ItemTypeDirectCostsList = useSelector(
    (state) => state.directCosts.ItemTypeDirectCosts
  );
  const DirectCostsBudgetAndMonth = useSelector(
    (state) => state.directCosts.getDirectCosts
  );
  const lodinggetDirectCosts = useSelector(
    (state) => state.directCosts.lodinggetDirectCosts
  );
  const ValidationAdministrativeCosts = useSelector(
    (state) => state.directCosts.validationDirectCosts
  );
  const BI_TimelineInformation = useSelector(
    (state) => state.BI_TimelineInformation.BI_TimelineInformation
  );
  const ItemTypeDirectCostsFilter = useSelector(
    (state) => state.directCosts.ItemTypeDirectCostsFilter
  );
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
//Get Objectives by aI_ApplicationInformationId 
  useEffect(() => {
   
    dispatch(
      GetObObjectives(props.PlaceOfCall == "InformationDirectCost"?props.aI_ApplicationInformation:  localStorage.getItem("aI_ApplicationInformationId")||
      decryptToken(AppGuid.AppGuid))
    );
    dispatch(GetABI_AB_ItemTypeDirectCosts());
  }, []);
  //Get ObjectivesActivities by aI_ApplicationInformationId and ObjectivesId
  useEffect(() => {
    // Dispatch an action to fetch objectives and activities based on application and objective IDs
    if(props.PlaceOfCall == "InformationDirectCost"){
      console.log(BI_ObjectivesId,"sdsdsdsdwdw");
      
      dispatch(
     
        GetObjectivesActivities({
          aI_ApplicationInformationId: props.aI_ApplicationInformation,
          ObjectivesId: parseInt(BI_ObjectivesId), // Parse the objective ID to an integer
        })
      );
    }else{
      dispatch(
     
        GetObjectivesActivities({
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId" // Retrieve the application information ID from local storage
          ),
          ObjectivesId: parseInt(BI_ObjectivesId), // Parse the objective ID to an integer
        })
      );
    }
    
  }, [BI_ObjectivesId]); // Effect runs whenever the `BI_ObjectivesId` changes
  
  

  useEffect(() => {
    dispatch(setClearValidationList());
  }, []);

  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    // Dispatch an action to fetch timeline information using the application information ID
    dispatch(
      GetBI_TimelineInformation(props.PlaceOfCall == "InformationDirectCost"?props.aI_ApplicationInformation:  localStorage.getItem("aI_ApplicationInformationId")||
      decryptToken(AppGuid.AppGuid))
    );
  }, []); // This effect runs only once when the component mounts
  

  const TimelineInformation = useSelector(
    (state) => state.BI_TimelineInformation.BI_TimelineInformation
  );
  //data of months dropdown
  const arrayOfMonths = [
    {
      numberOfMonth: 1,
      nameMonth: "الشهر الأول",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 2,
      nameMonth: "الشهر الثاني",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 3,
      nameMonth: "الشهر الثالث",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 4,
      nameMonth: "الشهر الرابع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 5,
      nameMonth: "الشهر الخامس",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 6,
      nameMonth: "الشهر السادس",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 7,
      nameMonth: "الشهر السابع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 8,
      nameMonth: "الشهر الثامن",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 9,
      nameMonth: "الشهر التاسع",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 10,
      nameMonth: "الشهر العاشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 11,
      nameMonth: "الشهر الحادي عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 12,
      nameMonth: "الشهر الثاني عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 13,
      nameMonth: "الشهر الثالث عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 14,
      nameMonth: "الشهر الرابع عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 15,
      nameMonth: "الشهر الخامس عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 16,
      nameMonth: "الشهر السادس عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 17,
      nameMonth: "الشهر السابع عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 18,
      nameMonth: "الشهر الثامن عشر",
      totalValue: 0,
      isChecked: false,
    },
    {
      numberOfMonth: 19,
      nameMonth: "الشهر التاسع عشر",
      totalValue: 0,
      isChecked: false,
    },
  ];

  let arrayOfMonthsFilter = arrayOfMonths.slice(
    0,
    TimelineInformation?.bI_ImplementationDurationMonths
      ?.implementationDurationMonths
  );

  const [arrayOfMonthsFilterAdd, setarrayOfMonthsFilterAdd] = useState(
    arrayOfMonths.slice(
      0,
      TimelineInformation?.bI_ImplementationDurationMonths
        ?.implementationDurationMonths
    )
  );

  /////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////
  const [factorial, setFactorial] = useState();
  const [factorialMinus, setFactorialMinus] = useState();

  ////////////////////////////////////////
//to add data on DirectCosts table
  const AddDirectCostsFun = () => {
    dispatch(
      AddDirectCosts({
        bI_DirectCostsAddeModel: {
          bI_ObjectivesId: BI_ObjectivesId,
          bI_ObjectiveActivitiesId: bI_ObjectiveActivitiesId,
          activityDescription: ActivityDescription,
          bI_AB_ItemTypeDirectCostsId: BI_AB_ItemTypeId,
          itemName: ItemName,
          descriptionAndDetailsOfItemCalculation:
            DescriptionAndDetailsOfItemCalculation,
          numberOfUnits: NumberOfUnits,
          unitPrice: UnitPrice,
          frequency: Frequency,
          beneficiaryContribution: ItemTypeDirectCostsFilter?.applyCondition
            ? factorial
            : beneficiaryContribution,
          shomanContribution: ItemTypeDirectCostsFilter?.applyCondition
            ? 0
            : factorialMinus,
          total: factorial,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        },
        bI_DistributionOfDirectCostsBudgetAddModel: arrayOfMonthsFilterAdd,
      })
    );
    //popup for info
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم اضافة المعلومات بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
    $(".close-btn").trigger("click");
  };
  /////////////////////////////////////get////////////////////////////////////////////////
  // get all data
  useEffect(() => {
    dispatch(setClearMonth());
    if (props.ViewData||props.PlaceOfCall=="InformationDirectCost") {

      if(props.PlaceOfCall=="InformationDirectCost"){
        dispatch(
          GetDirectCosts({ bI_DirectCostsGuid:props.bI_AB_EstimatedBudgetForAdministrativeCostsId })
        );
      }else{
        dispatch(
          GetDirectCosts({ bI_DirectCostsGuid: props.bI_DirectCostsGuid })
        );
      }
    }
  }, [props.bI_AB_EstimatedBudgetForAdministrativeCostsId,props.bI_DirectCostsGuid]);

  ////////////////////////////////////////////set vlaue/////////////////////////////////////////
//if from view or update mood set values on felds
console.log(DirectCostsBudgetAndMonth,"sdsdeeeeeeeedddsddwd");

  useEffect(() => {
    if (props.Action == "view" || props.Action == "edit"|| props.PlaceOfCall == "InformationDirectCost") {
      setBI_ObjectivesId(
        DirectCostsBudgetAndMonth?.directCosts?.bI_ObjectivesId
      );
      setBI_ObjectiveActivitiesId(
        DirectCostsBudgetAndMonth?.directCosts?.bI_ObjectiveActivitiesId
      );
      setActivityDescription(
        DirectCostsBudgetAndMonth?.directCosts?.activityDescription
      );
      setBI_AB_ItemTypeId(
        DirectCostsBudgetAndMonth?.directCosts?.bI_AB_ItemTypeDirectCostsId
      );
      setItemName(DirectCostsBudgetAndMonth?.directCosts?.itemName);
      setDescriptionAndDetailsOfItemCalculation(
        DirectCostsBudgetAndMonth?.directCosts
          ?.descriptionAndDetailsOfItemCalculation
      );
      setNumberOfUnits(DirectCostsBudgetAndMonth?.directCosts?.numberOfUnits);
      setUnitPrice(DirectCostsBudgetAndMonth?.directCosts?.unitPrice);
      setFrequency(DirectCostsBudgetAndMonth?.directCosts?.frequency);
      setBeneficiaryContribution(
        DirectCostsBudgetAndMonth?.directCosts?.beneficiaryContribution
      );
      setShomanContribution(
        DirectCostsBudgetAndMonth?.directCosts?.shomanContribution
      );
      setTotal(DirectCostsBudgetAndMonth?.directCosts?.total);
      dispatch(
        ItemTypeDirectCostsListFilter(
          DirectCostsBudgetAndMonth?.directCosts?.bI_AB_ItemTypeDirectCostsId
        )
      );
    }
  }, [DirectCostsBudgetAndMonth]);
  /////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    setFactorial(
      (!isNaN(NumberOfUnits) && NumberOfUnits ? NumberOfUnits : 0) *
      (!isNaN(Frequency) && Frequency ? Frequency : 0) *
      (!isNaN(UnitPrice) && UnitPrice ? UnitPrice : 0)
    );
  }, [NumberOfUnits, Frequency, UnitPrice]);

  useEffect(() => {
    setFactorialMinus(
      (factorial != undefined ? factorial : 0) -
      (!isNaN(beneficiaryContribution) && beneficiaryContribution
        ? beneficiaryContribution
        : 0)
    );
  }, [factorial, beneficiaryContribution]);

  ////////////////////////////////////////////////////edit/////////////////////////////////////////////
  //update data on DirectCosts table
  const EditDirectCostsFun = () => {
    dispatch(
      UpdateDirectCosts({
        bI_DirectCostsEditeModel: {
          bI_DirectCostsGuid:
            DirectCostsBudgetAndMonth?.directCosts?.bI_DirectCostsGuid,
          bI_ObjectivesId: BI_ObjectivesId,
          bI_ObjectiveActivitiesId: bI_ObjectiveActivitiesId,
          activityDescription: ActivityDescription,
          bI_AB_ItemTypeDirectCostsId: BI_AB_ItemTypeId,
          itemName: ItemName,
          descriptionAndDetailsOfItemCalculation:
            DescriptionAndDetailsOfItemCalculation,
          numberOfUnits: NumberOfUnits,
          unitPrice: UnitPrice,
          frequency: Frequency,
          beneficiaryContribution: ItemTypeDirectCostsFilter?.applyCondition
            ? factorial
            : beneficiaryContribution,
          shomanContribution: ItemTypeDirectCostsFilter?.applyCondition
            ? 0
            : factorialMinus,
          total: factorial,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        },
        bI_DistributionOfDirectCostsBudgetAddModel: dataEditMonth,
      })
    );
    // info popup
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم تعديل المعلومات بنجاح",
      showConfirmButton: false,
      timer: 1500,
      // width: "500px",
    });
//to close popup after ends action
    $(".close-btn").trigger("click");
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////
//add comma to numbers
  const numberWithCommas = (x) => {
    x = x != undefined ? x : "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
//to validate on do any action 
  const Validation = async () => {
    const validate = await dispatch(
      ValidationDirectCosts({
        bI_ObjectivesId: BI_ObjectivesId,
        bI_ObjectiveActivitiesId: bI_ObjectiveActivitiesId,
        activityDescription: ActivityDescription,
        bI_AB_ItemTypeDirectCostsId: BI_AB_ItemTypeId,
        itemName: ItemName,
        descriptionAndDetailsOfItemCalculation:
          DescriptionAndDetailsOfItemCalculation,
        numberOfUnits: NumberOfUnits,
        unitPrice: UnitPrice,
        frequency: Frequency,
        beneficiaryContribution: beneficiaryContribution,
        shomanContribution: ItemTypeDirectCostsFilter?.applyCondition
          ? 0
          : factorialMinus,
        total: Total,
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
        bI_AB_DistributionOfAdministrativeCostsBudgetList:
          props.Action == "add" ? arrayOfMonthsFilterAdd : dataEditMonth,
      })
    );
    //after validate end get action add or update 
    if (validate.payload) {
      let endLoop = false;
      let sumMonth = 0;
      if (props.Action == "add") {
        const sum = arrayOfMonthsFilterAdd.reduce((accumulator, current) => {
          const value = parseFloat(current.totalValue);
          if (!isNaN(value)) {
            return accumulator + value;
          }
          return accumulator; // تخطي القيم غير الرقمية
        }, 0); // القيمة الابتدائية هي 0
        sumMonth = sum;
        endLoop = true;
        //console.log(sum, "sumsum");
      } else if (props.Action == "edit") {

        const sum = dataEditMonth.reduce((accumulator, current) => {
          const value = parseFloat(current.totalValue);
          if (!isNaN(value)) {
            return accumulator + value;
          }
          return accumulator; // تخطي القيم غير الرقمية
        }, 0); // القيمة الابتدائية هي 0
        sumMonth = sum;
        endLoop = true;
      }

      if (endLoop) {
      //  validation on monthes
//
        if (
          sumMonth !=
          (ItemTypeDirectCostsFilter?.applyCondition ? 0 : factorialMinus)
          //   &&props.Action != "edit"
        ) {
          setShowMessageMonth(true);
          //console.log(
          //     sumMonth,
          //     factorialMinus,
          //     ItemTypeDirectCostsFilter?.applyCondition,
          //     "000000000000000000000000222"
          //   );
        } else {
          if (props.Action == "edit" && validate.payload.length === 0) {
            EditDirectCostsFun();
          } else {
            if (validate?.payload?.length === 0) {
              AddDirectCostsFun();
            }
          }
          setShowMessageMonth(false);
        }
      }
    }
  };

//render html
console.log(props.startMonth,"sdsdwwwwwwwwwwwwd");

  let Html = (
    <>
      <div className="containerBudgetDirectCostsAddEdit">
        <div className="FirstRow">
          <AllDropDownsAHSF
            fieldsName="objectiveName"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            dropdownType="normal"
            arrayOoptionList={ObjectivesList}
            KeyText={"objectiveName"}
            KeyValue={"bI_ObjectivesId"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"
                ? DirectCostsBudgetAndMonth?.directCosts?.bI_ObjectivesId
                : ""
            }
            onChange={(e) => {
              setBI_ObjectivesId(parseInt(e.target.value));
            }}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("objectiveName")
                : false
            }
          />
          <AllDropDownsAHSF
            fieldsName="activity"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            dropdownType="normal"
            arrayOoptionList={ObjectivesActivitiesList}
            KeyText={"activity"}
            KeyValue={"bI_ObjectiveActivitiesId"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts
                  ?.bI_ObjectiveActivitiesId
                : ""
            }
            onChange={(e) => {
              setBI_ObjectiveActivitiesId(parseInt(e.target.value));
            }}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("activity")
                : false
            }
          />
          <AllDropDownsAHSF
            fieldsName="ItemType"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            dropdownType="normal"
            arrayOoptionList={ItemTypeDirectCostsList}
            KeyText={"itemTypeNameAr"}
            KeyValue={"bI_AB_ItemTypeDirectCostsId"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts
                  ?.bI_AB_ItemTypeDirectCostsId
                : ""
            }
            onChange={(e) => {
              setBI_AB_ItemTypeId(parseInt(e.target.value));
              dispatch(ItemTypeDirectCostsListFilter(e.target.value));
              if (ItemTypeDirectCostsFilter?.applyCondition) {
                setBeneficiaryContribution(0);
              }
            }}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("ItemType")
                : false
            }
          />
        </div>
        <div className="SecondRow">
          <InputAHSF
            fieldsName="ItemNameDescriptionDirctCost"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts?.itemName
                : ""
            }
            onChange={(e) => {
              setItemName(e.target.value);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes(
                  "ItemNameDescriptionDirctCost"
                )
                : false
            }
          />
          <InputAHSF
            fieldsName="DescriptionAndDetailsOfItemCalculation"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts
                  ?.descriptionAndDetailsOfItemCalculation
                : ""
            }
            onChange={(e) => {
              setDescriptionAndDetailsOfItemCalculation(e.target.value);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes(
                  "DescriptionAndDetailsOfItemCalculation"
                )
                : false
            }
          />
          <InputAHSF
            fieldsName="ActivityDescriptionDirctCost"
            show={true}
            // disabled={props.disabledData ? true : false}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts?.activityDescription
                : ""
            }
            onChange={(e) => {
              setActivityDescription(e.target.value);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes(
                  "ActivityDescriptionDirctCost"
                )
                : false
            }
          />
        </div>
        <div className="ThirdRow">
          <InputAHSF
            fieldsName="NumberOfUnits"
            show={true}
            comma={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? numberWithCommas(
                  DirectCostsBudgetAndMonth?.directCosts?.numberOfUnits
                )
                : ""
            }
            onChange={(e) => {
              setNumberOfUnits(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("NumberOfUnits")
                : false
            }
          />
          <InputAHSF
            fieldsName="UnitPrice"
            show={true}
            comma={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost" ? true : false}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? numberWithCommas(
                  DirectCostsBudgetAndMonth?.directCosts?.unitPrice
                )
                : ""
            }
            onChange={(e) => {
              setUnitPrice(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("UnitPrice")
                : false
            }
          />
          <InputAHSF
            fieldsName="Frequency"
            show={true}
            disabled={props.Action == "view"||props.PlaceOfCall=="InformationDirectCost" ? true : false}
            comma={true}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? numberWithCommas(
                  DirectCostsBudgetAndMonth?.directCosts?.frequency
                )
                : ""
            }
            onChange={(e) => {
              setFrequency(parseFloat(e.target.value.replace(",", "")));
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("Frequency")
                : false
            }
          />
        </div>
        <div className="FourthRow">
          <InputAHSF
            fieldsName="BeneficiaryContribution"
            show={true}
            comma={ItemTypeDirectCostsFilter?.applyCondition ? true : false}
            disabled={
              props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"||props.PlaceOfCall=="InformationDirectCost"
                ? true
                : props.Action == "edit"
                  ? ItemTypeDirectCostsFilter?.applyCondition
                  : ItemTypeDirectCostsFilter?.applyCondition
                    ? true
                    : false
            }
            value={
              ItemTypeDirectCostsFilter?.applyCondition
                ? // 0
                numberWithCommas(factorial)
                : numberWithCommas(beneficiaryContribution)

              //   0
            }
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts
                  ?.beneficiaryContribution
                : ""
            }
            onChange={(e) => {
              setBeneficiaryContribution(
                parseFloat(
                  e.target.value && !isNaN(beneficiaryContribution)
                    ? e.target.value.replace(",", "")
                    : 0
                )
              );
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes(
                  "BeneficiaryContribution"
                )
                : false
            }
          />
          <InputAHSF
            fieldsName="ShomanContribution"
            show={true}
            disabled={true}
            comma={true}
            value={
              ItemTypeDirectCostsFilter?.applyCondition
                ? 0
                : numberWithCommas(factorialMinus)
            }
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts?.shomanContribution
                : ""
            }
            onChange={(e) => {
              setShomanContribution(
                parseFloat(e.target.value.replace(",", ""))
              );
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("ShomanContribution")
                : false
            }
          />
          <InputAHSF
            fieldsName="Total"
            show={true}
            disabled={true}
            comma={true}
            value={numberWithCommas(parseFloat(factorial))}
            defaultValue={
              props.Action == "view" || props.Action == "edit"||props.PlaceOfCall=="InformationDirectCost"

                ? DirectCostsBudgetAndMonth?.directCosts?.total
                : ""
            }
            onChange={(e) => {
              setTotal(factorial);
            }}
            // showValidationMessage={validationOpject?.objectiveName ? true : false}
            validationMessage={"حقل اجباري"}
            showValidationMessage={
              ValidationAdministrativeCosts
                ? ValidationAdministrativeCosts.includes("Total")
                : false
            }
          />
        </div>
      </div>
      <div className="validationMessageMonyh">
        {showMessageMonth ? <>{JsonDataa.JsonData?.MessageMonth}</> : <></>}
        <br></br>
        <br></br>
        {ValidationAdministrativeCosts &&
          ValidationAdministrativeCosts.includes("monthes") ? (
          <>يجب اختيار شهر واحد على الاقل</>
        ) : (
          <></>
        )}


        {ValidationAdministrativeCosts &&
          ValidationAdministrativeCosts.includes("ShomanContribution") ? (
          <>يجب أن تكون قيمة مساهمة شومان أكبر من أو تساوي صفر</>
        ) : (
          <></>
        )}
      </div>
      {BI_TimelineInformation?.bI_ImplementationDurationMonthsId ? (
        <MonthsImplementationDirectBudgetCosts
          setDataEditMonth={setDataEditMonth}
          setarrayOfMonthsFilterAdd={setarrayOfMonthsFilterAdd}
          action={props.PlaceOfCall=="InformationDirectCost"?"view":props.Action}
          data={
            props.PlaceOfCall == "InformationDirectCost"?DirectCostsBudgetAndMonth?.distributionOfDirectCostsBudgetList?.slice(props.startMonth, props.endMonth):
            props.monthDataApi
              ? DirectCostsBudgetAndMonth?.distributionOfDirectCostsBudgetList
              : arrayOfMonthsFilterAdd
          }
        />
      ) : (
        <p style={{ color: "red", marginRight: "30px" }}>
          يجب اختيار مدة التنفيذ(الاشهر) لأظهار الشهور
        </p>
      )}

      {props.Action == "view"||props.PlaceOfCall=="InformationDirectCost"
 ? (
        <></>
      ) : (
        <>
          <div className="containerButton">
            <ButtonAHSF onClick={Validation} text={"حفظ"} show={true} />
          </div>
        </>
      )}
    </>
  );

  return (
    <>
      {(props.Action == "edit" || props.Action == "view"|| props.PlaceOfCall == "InformationDirectCost") &&
        !lodinggetDirectCosts &&
        DirectCostsBudgetAndMonth?.directCosts &&
        DirectCostsBudgetAndMonth?.distributionOfDirectCostsBudgetList ? (
        <>{Html}</>
      ) : (
        <>{props.Action  == "add" ? <>{Html}</> : <></>}</>
      )}
    </>
  );
};

export default BudgetDirectCostsAddEdit;
